// Avatar picker grid for the add/edit-kid form. Uses the shared emoji avatar
// catalog from @fajrarabi/ui.

import { AVATAR_CATALOG, cn } from '@fajrarabi/ui';

export function AvatarPicker({
  value,
  onChange,
}: {
  value: string;
  onChange: (slug: string) => void;
}) {
  return (
    <div className="grid grid-cols-6 gap-2">
      {AVATAR_CATALOG.map((a) => {
        const selected = a.slug === value;
        return (
          <button
            key={a.slug}
            type="button"
            onClick={() => onChange(a.slug)}
            aria-pressed={selected}
            aria-label={a.label}
            className={cn(
              'grid aspect-square place-items-center rounded-2xl text-2xl transition-colors',
              selected
                ? 'bg-sun-300 ring-2 ring-burgundy-500'
                : 'bg-cream-100 ring-1 ring-burgundy-500/10 hover:bg-cream-200',
            )}
          >
            <span aria-hidden="true">{a.emoji}</span>
          </button>
        );
      })}
    </div>
  );
}
